import { Component, Injector, OnInit } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { UserDao } from '@app/dao/user/user.dao';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'credit-guarantees',
    templateUrl: './credit-guarantees.component.html',
    styleUrls: ['./credit-guarantees.component.scss'],
    standalone: false
})
export class CreditGuaranteesComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  owners: any[] = [];
  premiumTypeRef: any[] = [
    {
      id: 'CI',
      label: 'CI',
    },
    {
      id: 'CRD',
      label: 'CRD',
    },
  ];
  typeReglementRef = [
    {
      id: 'CAPITAL',
      label: 'Capital',
    },
    {
      id: 'RENTE',
      label: 'Rente',
    },
  ];
  deductibleRef = [
    {
      id: 'TRENTE',
      label: '30 jours',
    },
    {
      id: 'SOIXANTE',
      label: '60 jours',
    },
    {
      id: 'QUATRE_VINGT_DIX',
      label: '90 jours',
    },
    {
      id: 'CENT_VINGT',
      label: '120 jours',
    },
    {
      id: 'CENT_QUATRE_VINGT',
      label: '180 jours',
    },
  ];

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
    private userDao: UserDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
    this.applyDevisPremiumType();
    this.userDao.getOwners().subscribe(owners => {
      this.owners = owners;
    });
  }

  private applyDevisPremiumType(): void {
    const premiumType = this.subscriptionFacade.aeDevisPremiumType;
    if (!premiumType) return;
    this.form?.get('products')?.get('0')?.get('parameters')?.get('premiumType')?.setValue(premiumType, { emitEvent: false });
    this.subscriptionFacade.aeDevisPremiumType = null;
  }
  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }

  get guarantees(): UntypedFormArray {
    return this.form
      .get('products')
      .get('0')
      .get('parameters')
      .get('guarantees') as UntypedFormArray;
  }

  getOwnerLabel(ownerId: number): string {
    return this.owners.find(owner => owner.id === ownerId)?.label || '';
  }
}
